import { render, staticRenderFns } from "./CbsModal.vue?vue&type=template&id=fa16e22a&scoped=true"
import script from "./CbsModal.vue?vue&type=script&lang=js"
export * from "./CbsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa16e22a",
  null
  
)

export default component.exports